import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View, SuccessMessage } from '@olxbr/design-system'
import { Link } from '@olxbr/ds-web'

import Form from '../../atoms/Form'
import PinCode from '../../molecules/PinCode'
import { ErrorAlertbox } from '../../atoms/ErrorAlertbox/ErrorAlertbox'
import { formatedTime } from '../../../util/date'
import { LoadingSpinner } from '../../molecules/LoadingSpinner/LoadingSpinner'
import { RevalidateCard } from '../../organisms/RevalidateCard'
import { RevalidationConfirmResendCodeModal } from '../RevalidationConfirmResendCodeModal'
import { breakpoints } from '../../../util/medias'

const Content = styled(View)`
  display: flex;
  flex: 1;
  flex-direction: column;
`

const FormContent = styled(Form)`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const MaskedData = styled.div`
  display: flex;
  max-width: 272px;
  width: 100%;
  justify-content: center;
  align-self: center;
  margin-bottom: var(--spacing-3);
  padding: var(--spacing-1);
  border: 1px solid var(--color-neutral-90);
  border-radius: var(--border-radius-4);
`

const EmailText = styled.span`
  font-weight: var(--font-weight-bold);
`

const ResendCodeWrapper = styled.div`
  display: flex;
  margin-top: var(--spacing-3);

  @media (max-width: ${breakpoints.tablet}px) {
    justify-content: center;
  }
`

export const RevalidationCheckPinCodeTemplate = ({
  title,
  description,
  alertDescription,
  data,
  remainingAttempts,
  onBack,
  lockTime,
  resendCode,
  isResending,
  isSubmitting,
  error,
  closeResendCodeSuccessMessage,
  onPinCodeChange,
  showResendCodeSuccessMessage,
  infoDescription,
}) => {
  const [modalOpen, setModalOpen] = useState(false)

  const closeModal = event => {
    if (event) event.preventDefault()
    setModalOpen(false)
  }

  const onResendClick = () => setModalOpen(true)

  const onResendConfirm = () => {
    resendCode()
    closeModal()
  }

  const DescriptionElement = () => {
    return (
      <p className="typo-body-medium">
        {infoDescription} &nbsp;
        <EmailText>{data}</EmailText>?
      </p>
    )
  }

  return (
    <RevalidateCard
      onBack={onBack}
      title={title}
      description={description}
      alertDescription={alertDescription}
    >
      <Content>
        {isSubmitting ? (
          <LoadingSpinner label="Concluindo verificação" aria-label="Validando código" />
        ) : (
          <>
            <MaskedData>
              <span className="typo-body-small text-neutral-120">{data}</span>
            </MaskedData>

            {error && (
              <ErrorAlertbox title={error.title} showContactUs={error.showContactUs}>
                {error.message}
              </ErrorAlertbox>
            )}

            <FormContent method="POST" noValidate>
              <PinCode
                disabled={isSubmitting || remainingAttempts === 0}
                onChange={(pincode, isValid) => {
                  onPinCodeChange(pincode, isValid)
                }}
              />
            </FormContent>
            <ResendCodeWrapper>
              <Link
                aria-label="Reenviar código"
                disabled={lockTime > 0 || isResending || remainingAttempts === 0}
                onClick={onResendClick}
                size="medium"
                tag="button"
              >
                {lockTime > 0 ? `Reenviar código em ${formatedTime(lockTime)}` : 'Reenviar código'}
              </Link>
            </ResendCodeWrapper>
            <SuccessMessage
              text="Código reenviado com sucesso"
              show={showResendCodeSuccessMessage}
              onClose={closeResendCodeSuccessMessage}
            />
            <RevalidationConfirmResendCodeModal
              onConfirm={onResendConfirm}
              closeModal={closeModal}
              isSubmitting={isResending}
              isOpen={modalOpen}
              descriptionElement={<DescriptionElement />}
            />
          </>
        )}
      </Content>
    </RevalidateCard>
  )
}

RevalidationCheckPinCodeTemplate.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  alertDescription: PropTypes.string,
  data: PropTypes.string,
  remainingAttempts: PropTypes.number,
  onBack: PropTypes.func,
  lockTime: PropTypes.number,
  resendCode: PropTypes.func,
  isSubmitting: PropTypes.bool,
  error: PropTypes.exact({
    title: PropTypes.string,
    showContactUs: PropTypes.bool,
    message: PropTypes.string,
  }),
  infoDescription: PropTypes.string,
  closeResendCodeSuccessMessage: PropTypes.func,
  onPinCodeChange: PropTypes.func,
  showResendCodeSuccessMessage: PropTypes.bool,
  isResending: PropTypes.bool,
}
